import * as React from "react";
import { SecondaryHeading, HeadingTitle } from "../..";
import { RenderMarketNames } from "../RenderMarketNames";
import { CardType, MarketTemplate } from "../../../../../data";

export class RenderCustomHeading extends React.PureComponent < {
    id: string
    marketNames: string[][]
    marketTemplates: MarketTemplate[]
    cardType: CardType
}, {} > {
    render() {
        return <SecondaryHeading
                key={`subheading-${this.props.id}`}
                cardType={this.props.cardType}
            >
                <HeadingTitle name={""} eventsCount={""} />
                <RenderMarketNames marketNames={this.props.marketNames} marketTemplates={this.props.marketTemplates} />
            </SecondaryHeading>
    }
}